import { Typography } from '@automata/ui';
import { SvgIconTypeMap } from '@mui/material';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import Tooltip from '@mui/material/Tooltip';

export type Props = {
  message: string | string[];
  icon: OverridableComponent<SvgIconTypeMap<{}, 'svg'>> & {
    muiName: string;
  };
  iconColor?: SvgIconTypeMap['props']['color'];
};

const NodeIndicator = ({ icon: Icon, message, iconColor }: Props) => {
  const tooltipContentArraySafe = Array.isArray(message) ? message : [message];

  return (
    <Tooltip
      title={
        <Box p={2}>
          {tooltipContentArraySafe.length > 1 ? (
            <List sx={{ listStyleType: 'disc', p: 0 }}>
              {tooltipContentArraySafe.map((item) => (
                <ListItem key={item} sx={{ display: 'list-item', p: 0 }}>
                  {item}
                </ListItem>
              ))}
            </List>
          ) : (
            <Typography variant="body2">{message}</Typography>
          )}
        </Box>
      }
    >
      <Icon
        aria-hidden={false}
        aria-label={tooltipContentArraySafe.join(', ')}
        color={iconColor}
      />
    </Tooltip>
  );
};

export default NodeIndicator;
